export const ICON_COLORS = {
    default: "#fff",
    open: "#FFDA7E",
    closed: "#ABF0B0",
    notAnswered: "#47d2ff"
}